import React, { useEffect, useState } from 'react';

// MISC
import { ButtonType } from 'components/Atoms/ButtonAtom/ButtonAtomModel';
import { TextType } from 'components/Atoms/CustomText/CustomTextModel';
import { CookieItem, CookiesPreferencesModalProps } from 'view/CookieModule/CookieModuleModel';

//ASSETS
import XSign from "assets/svg/XSignWhite.svg";

// STYLES
import { ButtonContainer, CloseButtonContainer, Description, IconSimple, ModalBackground, ModalBody, ModalContainer, ModalContent, ModalHeader } from 'view/CookieModule/CookieModuleStyled';

// COMPONENTS
import ButtonAtom from 'components/Atoms/ButtonAtom/ButtonAtom';
import CustomText from 'components/Atoms/CustomText/CustomText';
import { COLORS } from 'constants/variables';
import { useSelector } from 'react-redux';
import { accessibilityBiggerCursorSelector } from 'slices/UISlice/uiSliceSelectors';
import { translations } from 'view/CookieModule/config/cookieModuleConfig';
import { getCookie, isTruthy } from 'view/CookieModule/helpers/cookieHelper';
import CustomCookiesDropdown from '../CustomCookiesDropdown/CustomCookiesDropdown';

// TRANSLATIONS

const CookiesPreferencesModal: React.FC<CookiesPreferencesModalProps> = ({
  showModal,
  setShowModal,
  necessaryCookies,
  analyticsCookies,
  setNecessaryCookies,
  setAnalyticsCookies,
  handleSaveSettings,
  language // Add language prop
}) => {

  const [isLoading, setIsLoading] = useState(true);
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  useEffect(() => {
    if (biggerCursor) {
      const cursorIcon = require("assets/img/Cursor.png");
      const cursor = document.querySelector("html");
      cursor.style.cursor = `url(${cursorIcon}), auto`;
    } else {
      const cursor = document.querySelector("html");
      cursor.style.cursor = "auto";
    }
  }, [biggerCursor]);

  useEffect(() => {
    if (showModal) {
      const updatedNecessaryCookies = necessaryCookies.map(cookie => ({
        ...cookie,
        checked: true,
      }));
      const updatedAnalyticsCookies = analyticsCookies.map(cookie => ({
        ...cookie,
        checked: (isTruthy(getCookie(cookie.title)) && isTruthy(`${getCookie(cookie.title)}_2FGL3Y9F1R`)),
      }));

      setNecessaryCookies(updatedNecessaryCookies);
      setAnalyticsCookies(updatedAnalyticsCookies);
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [showModal]); // Only trigger when showModal changes

  const handleNecessaryCookiesChange = (newItems: CookieItem[]) => {
    // Prevent changes to necessary cookies
  };

  const handleAnalyticsCookiesChange = (newItems: CookieItem[]) => {
    setAnalyticsCookies(newItems);
  };

  const handleSave = () => {
    handleSaveSettings();
    setShowModal(false);
  };

  // Get translations based on language
  const t = translations[language];

  return (
    (showModal && !isLoading) && (
      <ModalBackground>
        {/* <CloseButtonWrapper>
          <CloseButton onClick={() => setShowModal(false)}>&times;</CloseButton>
        </CloseButtonWrapper> */}

        <ModalContainer>

          <ModalContent>
            <CloseButtonContainer onClick={() => setShowModal(false)} biggerCursor={biggerCursor}>
              <IconSimple src={XSign} alt="Close Button" />
            </CloseButtonContainer>
            <ModalHeader>
              <CustomText
                type={TextType.H2}
                text={t.settingsTitle}
                color={COLORS.Orange}
              />
            </ModalHeader>
            <ModalBody>
              <Description>
                <CustomText
                  type={TextType.P2}
                  text={t.settingsDescription}
                  color={COLORS.Cultured}
                />
              </Description>

              <CustomCookiesDropdown
                title={t.necessaryTitle}
                description={t.necessaryDescription}
                items={necessaryCookies}
                onItemsChange={handleNecessaryCookiesChange}
              />
              <CustomCookiesDropdown
                title={t.analyticsTitle}
                description={t.analyticsDescription}
                items={analyticsCookies}
                onItemsChange={handleAnalyticsCookiesChange}
              />
            </ModalBody>
            <ModalBody>

            </ModalBody>
            <ButtonContainer>
              <ButtonAtom
                type={ButtonType.CookieButton}
                text={t.saveButtonText}
                onClick={handleSave}
              />
            </ButtonContainer>
          </ModalContent>
        </ModalContainer>
      </ModalBackground>
    )
  );
};

export default CookiesPreferencesModal;
